import { createFileRoute } from '@tanstack/react-router';

import { USER_ROLES } from '~/features/auth/roles';
import { protectedRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/hcp-admin/archive')({
  component: RouteComponent,
  beforeLoad: () => {
    protectedRoute({
      roles: [
        USER_ROLES.AdminAbbott,
        USER_ROLES.HcpAdmin,
        USER_ROLES.NonHcpAdmin,
      ],
    });
  },
});

function RouteComponent() {
  return <div>Hello from /archive!</div>;
}
